export default __webpack_public_path__ + "static/786-7ea32f41a711db0213b64ab2716b8914.gif";